import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classes from "./breadcrumbs.module.css";
import { useMegaMenu } from "../../Pregrine/MegaMenu/useMegaMenu";

const Breadcrumbs = ({ setCategoryNames }) => {
  const megaMenuprops = useMegaMenu();
  const { MegaMenuData } = megaMenuprops;
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const paths = pathname.split("/").filter((path) => path !== "");
  const detailPagePath = state?.url?.split("/").filter((path) => path !== "");

  const findCategoryNameByUrlKey = (category, productURLKey) => {
    if (!category) {
      return null;
    }

    if (category.url_key === productURLKey) {
      return category.name;
    }

    if (
      category.children &&
      Array.isArray(category.children) &&
      category.children.length > 0
    ) {
      for (const child of category.children) {
        const childResult = findCategoryNameByUrlKey(child, productURLKey);
        if (childResult !== null) {
          return childResult;
        }
      }
    }

    return null;
  };

  const getCategoryName = (productURLKey) => {
    if (productURLKey && productURLKey) {
      return findCategoryNameByUrlKey(
        MegaMenuData && MegaMenuData.category,
        productURLKey
      );
    }
    return null;
  };

  useEffect(() => {
    const currentPage = paths[0];
    if (setCategoryNames) {
      if (currentPage.toLowerCase() === "product") {
        const detailPagePath = state?.url
          ?.split("/")
          .filter((path) => path !== "");
        if (detailPagePath) {
          const names = detailPagePath.map((item) =>
            findCategoryNameByUrlKey(MegaMenuData?.category, item)
          );
          setCategoryNames(names);
        }
      } else {
        const allPaths = paths.slice(1, paths.length);
        setCategoryNames(allPaths);
      }
    }
  }, [state, MegaMenuData]);

  return (
    <section className={classes.crumb}>
      <div className="container">
        <ul className={classes.breadcrumb}>
          <li>
            <Link className={classes.link} to="/">
              Home
            </Link>
          </li>

          {detailPagePath &&
            detailPagePath.map((item, index) => {
              if (index === 0) return null;
              const path = detailPagePath.slice(0, index + 1).join("/");
              return (
                <li key={index}>
                  <a
                    className={classes.link}
                    onClick={() => navigate(`/${path}`)}
                  >
                    {getCategoryName(item)}
                  </a>
                </li>
              );
            })}

          {paths && paths[0] === "category" && paths.length === 4 ? (
            <>
              <li>
                <a
                  className={classes.link}
                  onClick={() => navigate(`/category/${paths[1]}`)}
                >
                  {getCategoryName(paths[1])}
                </a>
              </li>

              <li>
                <a
                  className={classes.link}
                  onClick={() => navigate(`/category/${paths[1]}/${paths[2]}`)}
                >
                  {getCategoryName(paths[2])}
                </a>
              </li>
              <li>{getCategoryName(paths[3])}</li>
            </>
          ) : paths && paths[0] === "category" && paths.length === 3 ? (
            <>
              <li>
                <a
                  className={classes.link}
                  onClick={() => navigate(`/category/${paths[1]}`)}
                >
                  {getCategoryName(paths[1])}
                </a>
              </li>
              <li>{getCategoryName(paths[2])}</li>
            </>
          ) : paths && paths[0] === "category" && paths.length === 2 ? (
            <li>{getCategoryName(paths[1])}</li>
          ) : paths &&
            paths[0] === "product" &&
            paths &&
            paths[1].endsWith(".html") ? (
            <li>{paths[1].slice(0, -5)} </li>
          ) : (
            <li>{paths[0]}</li>
          )}
        </ul>
      </div>
    </section>
  );
};

export default Breadcrumbs;
